import { createContext, useContext, useEffect, useState } from "react";
import api from "../api/api";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

    const checkAuth = async () => {
  try {
    const res = await api.get("/api/auth/me");
    if (res.data.authenticated) {
      setUser(res.data.user);
    } else {
      setUser(null);
    }
  } catch {
    setUser(null);
  } finally {
    setLoading(false);
  }
};

  const login = async (username, password) => {
      console.log("LOGIN FN CALLED", username, password);

    await api.post("/api/auth/login", { username, password });
    await checkAuth();
  };

  const logout = async () => {
    await api.post("/api/auth/logout");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
